export class HandledError extends Error {
  title: string;

  constructor({ title, message }: { title: string; message: string }) {
    super(message);
    this.title = title;
  }
}
